import { createSelector } from 'reselect';

import { Selector } from '../../../../types/selectors';
import { selectMissionCumulatedFreebetsRewardsFromAchievements } from '../../selectors/missionAchievements';
import { selectMissionFreebetsRewardAmount, selectMissionFreebetsRewardDisplayValue } from '../../selectors/missions';

export const selectMissionFreebetsPotentialGain: Selector<number> = createSelector(
  [
    selectMissionFreebetsRewardAmount,
    selectMissionCumulatedFreebetsRewardsFromAchievements,
    selectMissionFreebetsRewardDisplayValue,
  ],
  (missionFreebetsRewardAmount, cumulatedMissionFreebetsRewardsFromAchievements, displayValue) =>
    typeof displayValue === 'number'
      ? displayValue
      : missionFreebetsRewardAmount + cumulatedMissionFreebetsRewardsFromAchievements,
);

type MissionFreebetsPotentialGainContainerPropsType = {
  amount: number;
};

const selectMissionFreebetsPotentialGainContainerProps: Selector<MissionFreebetsPotentialGainContainerPropsType> =
  createSelector([selectMissionFreebetsPotentialGain], (potentialGain) => ({
    amount: potentialGain,
  }));

export default selectMissionFreebetsPotentialGainContainerProps;
